export default {
    methods: {
        /**
         *  Преобразование datetime в привычный пользователю вид.
         *  Адаптируется под часовой пояс пользователя.
         * @param datetime {datetime} - дата и время
         * @returns {string} - дата и время в формате `24 июля 2019 г., 16:50`
         */
        _dateTimeFormat(datetime) {
            let dateOptions = {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                    hour: 'numeric',
                    minute: 'numeric',
                };

            return this._dateLocaleString(datetime, dateOptions).replace(',', '');
        },

        /**
         *  Преобразование datetime в привычный пользователю вид даты.
         *  Адаптируется под часовой пояс пользователя.
         * @param datetime {datetime} - дата и время
         * @param withYearEnding {boolean} - если `true`, будет добавлено окончание `г.` к году
         * @returns {string} - дата в формате `24 июля 2019`
         */
        _dateFormat(datetime, withYearEnding = false) {
            let dateOptions = {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                },
                result = this._dateLocaleString(datetime, dateOptions);

            if (!withYearEnding) {
                result = result.replace('г.', '');
            }

            return result;
        },

        /**
         * Преобразование даты в строку с заданными параметрами, учитывает часовой пояс пользователя.
         * @param datetime
         * @param parameters
         * @returns {string}
         * @private
         */
        _dateLocaleString(datetime, parameters = {}) {
            let date = new Date(datetime);

            parameters['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

            return date.toLocaleDateString(appLocale, parameters);
        }
    }
};
